import DoubleUploadImgSchema from "./components/DoubleUploadImg/schema";
import inputSchema from './components/input/schema';
import switchSchema from './components/switch/schema';
import selectSchema from './components/select/schema';
import passwordSchema from './components/password/schema';
import digitSchema from './components/digit/schema';
import moneySchema from './components/money/schema';
import textareaSchema from './components/textarea/schema';
import dateSchema from './components/date/schema';
import dateTimeSchema from "./components/dateTime/schema"
import dateTimeRangeSchema from "./components/dateTimeRange/schema"
import dateRangeSchema from './components/dateRange/schema';
import BankCardNumberSchema from "./components/BankCardNumber/schema"
import inputSearchSchema from "./components/inputSearch/schema"
import UploadImgSchema from "./components/UploadImg/schema"
import groupSchema from "./components/Group/schema"
import tableSchema from "./components/TableWapper/schema"
// import modalSchema from "./components/ModalWapper/schema"
import radioSchema from "./components/Radio/schema"
import BottomSubButtonSchema from "./components/BottomSubButton/schema"
// import ColorPickerSchema from "./components/ColorPicker/schema";
import mobileSchema from "./components/mobileWapper/schema"
import checkboxSchema from "./components/Checkbox/schema"

export const FormSchema = {
  BankCardNumber: BankCardNumberSchema,
  DoubleUploadImg: DoubleUploadImgSchema(),
  dateTime: dateTimeSchema,
  IDCard: DoubleUploadImgSchema("IDCard"),
  text: inputSchema,
  checkbox: checkboxSchema,
  switch: switchSchema,
  select: selectSchema,
  password: passwordSchema,
  digit: digitSchema,
  money: moneySchema,
  textarea: textareaSchema,
  date: dateSchema,
  dateRange: dateRangeSchema,
  UploadImg: UploadImgSchema,
  "@group": groupSchema,
  table: tableSchema,
  // modalSchema,
  radio: radioSchema,
  inputSearch: inputSearchSchema,
  BottomSubButton: BottomSubButtonSchema,
  // ColorPickerSchema,
  dateTimeRange: dateTimeRangeSchema,
  mobile: mobileSchema
}

export const acceptArrayFun = () => {
  const acceptArray: string[] = [];
  for (const i in FormSchema) {
    acceptArray.push(FormSchema[i]?.valueType);
  }
  return {
    acceptArray,
  };
}